import XLSX from 'xlsx'

const checkHeaders = (HEADERS, headers) => {
  return headers.length === HEADERS.length && (headers.filter((ele) => !HEADERS.includes(ele.toLowerCase())).length === 0 || 
        headers.filter((ele) => !HEADERS.includes(ele)).length === 0)
}

const csvToJson = (file, HEADERS, schema, setData) => {
  const reader = new FileReader()
  const rABS = !!reader.readAsBinaryString
  reader.onload = (e) => {
    try {
      /* Parse data */
      const bstr = e.target.result
      const type = file.name.includes('.csv') ? 'string' : rABS ? 'binary' : 'array'
      const wb = XLSX.read(bstr, { type, raw: true, cellText:false, cellDates:true })
      /* Get first worksheet */
      const wsname = wb.SheetNames[0]
      const ws = wb.Sheets[wsname]

      /* converting sheet to csv(comma seperated string) */ 
      const csvData = XLSX.utils.sheet_to_csv(ws, { header: 1, raw: false, blankrows: false, dateNF:'dd-mm-yyyy' })

      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, blankrows: false, dateNF:'dd-mm-yyyy' })
      /* Update state */
      let headerKeys = data[0]

      if (checkHeaders(HEADERS, headerKeys)) {
        headerKeys = headerKeys.map((ele) => ele.toLowerCase().replaceAll(' ', '_'))
        const formattedData = []
        const records = data.slice(1)

        records.forEach((record) => {
          var prepareRow = {},
            originalRow = {}
          record.forEach((cell, index) => {
            prepareRow[headerKeys[index]] = ['entity_name'].includes(headerKeys[index]) ? String(cell).trim() : String(cell).toLowerCase().trim()
            originalRow[headerKeys[index]] = String(cell)
          })

          schema.validate(prepareRow, { stripUnknown: true, abortEarly: false }).catch(function (err) {
            err.inner && err.inner.reduce(
              (errors, currentValidation) =>
                (originalRow.errors = Object.assign(errors, {
                  [currentValidation.path]: currentValidation.errors[0],
                })),
              {}
            )
          })
          formattedData.push(originalRow)
        })
        setTimeout(() => setData(formattedData, headerKeys, null, csvData), 0)
      } else {
        setData([], [], { title: 'Uploaded file headers are not matched with given headers in sample file. we recommend downloading the latest sample file and using it for upload', description: 'Please upload your file with correct headers' })
      }
    } catch (err) {
      setData([], [], { title: 'Uploaded file is not in correct format', description: 'Please upload your file in csv or xlsx format only' })
    }
  }

  if (file.name.includes('.csv') || file.name.includes('.xlsx')) {
    if (rABS) reader.readAsBinaryString(file)
    else reader.readAsArrayBuffer(file)
  } else {
    setData([], [], { title: 'Uploaded file is not in correct format', description: 'Please upload your file in csv or xlsx format only' })
  }
}

export default csvToJson
